const experimentsRequire = require.context(
  'app/common/lib/experiments/config',
  false,
  /\.json$/,
);
window.abTests = experimentsRequire.keys().reduce((acc, path) => {
  const segments = path.split('/');
  const name = segments[segments.length - 1].split('.')[0];
  acc[name] = experimentsRequire(path);

  return acc;
}, {});
